export interface AppState {
  initialized: boolean;
}

export const initialAppState: AppState = {
  initialized: false,
};
